// Sprint 36 item 2: the player pages that open inside the game as panels (index.html #panel). Pure; the server and the browser both read it.
// /<name> is the game with that panel open; /panel/<name> is the page the panel's frame loads.
export const PANELS = {
  roadmap: "What's coming",
  overview: 'How the game works',
  verify: 'Verify a shift',
  rooms: 'Pick a room',
  lineup: 'The Lineup',
  minigames: 'Practice the mini-games',
  leaders: 'Leaderboards',
  logbook: 'Your logbook',
  stairwell: 'The stairwell',
  builder: 'Build a neighbour',
  points: 'How points work',
};

export const panelOf = pathname => {
  const m = /^\/([a-z]+)\/?$/.exec(pathname);
  return m && Object.hasOwn(PANELS, m[1]) ? m[1] : null;
};

export const frameSrc = (name, search = '', hash = '') => `/panel/${name}${search}${hash}`;

// A page inside the panel leaves by asking the game: the door closes the panel, another panel page opens in the same panel
// (no reload of the game behind it), any other page is a plain visit.
export function leave(url, win = globalThis) {
  const u = new URL(url, win.location.href);
  if (win.top === win) { win.location.href = url; return; }
  const home = u.origin === win.location.origin;
  if (home && u.pathname === '/' && !u.search && !u.hash) win.parent.postMessage({ t: 'panel-close' }, win.location.origin);
  else if (home && panelOf(u.pathname)) win.parent.postMessage({ t: 'panel-open', url: u.pathname + u.search + u.hash }, win.location.origin);
  else win.top.location.href = u.href;
}
